import { createStyles } from '@material-ui/core/styles'

const style = () =>
  createStyles({
    link: {
      textDecoration: 'none'
    },
  })

export default style
